const Footer= () => {
    return (
      <footer>
          
          <article id="contact">
                <ul>
                    <li>
                        <a href="tel:3605312389" target="_blank" rel="noreferrer">360.531.2389</a>
                    </li>
                    <li>
                        <a href="mailto:chriskimball.dev@gmail.com" target="_blank" rel="noreferrer">chriskimball.dev@gmail.com</a>
                    </li>
                    <li>
                        <a href="https://github.com/chriskimball" target="_blank" rel="noreferrer">github</a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/in/chriskimball1" target="_blank" rel="noreferrer">linkedin</a>
                    </li>
                </ul>
            </article>
            <p>© Copyright 2022 Chris Kimball</p>
      </footer>
    );
  }
  
export default Footer;
  